import React from 'react';
import style from './tree-navigation.module.less';
import { TreeNavPropType } from '../../prop-types/tree-navigation';
import { TreeItem } from './tree-item';

const DEFAULT_BUILD_TAG_PROPS = () => ({});

export const TreeNavigation = React.memo(
  ({ isHighlighted = false, items, onItemSelected, buildTagProps = DEFAULT_BUILD_TAG_PROPS, onExpandClick }) => {
    return (
      <div aria-multiselectable='false' className={style['tree-navigation']} data-testid='tree-navigation' role='tree'>
        {items.map((item) => (
          <TreeItem
            key={item.id}
            buildTagProps={buildTagProps}
            isHighlighted={isHighlighted}
            item={item}
            onExpandClick={onExpandClick}
            onItemSelected={onItemSelected}
            shouldRenderAnIcon={item.shouldRenderAnIcon}
            treeItemClassName={item.treeItemClassName}
          />
        ))}
      </div>
    );
  },
);

TreeNavigation.propTypes = TreeNavPropType;

export { TreeNavigation as TreeNav };
